import { forwardRef } from "react";
function SvgRawSpanishIcon({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={15}
      height={15}
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="#767676" fillRule="evenodd">
        <path d="M7.5 0a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15Zm0 13.8a6.296 6.296 0 0 1-6.3-6.3c0-3.483 2.817-6.3 6.3-6.3 3.483 0 6.3 2.817 6.3 6.3 0 3.483-2.817 6.3-6.3 6.3Z" />
        <path d="M3.916 9.8V4.837h3.108v.91H4.882v1.134h1.939v.861H4.882V8.89h2.142v.91H3.916Zm6.545-3.514a1.162 1.162 0 0 0-.074-.227.727.727 0 0 0-.157-.228.842.842 0 0 0-.27-.175 1.028 1.028 0 0 0-.402-.07.921.921 0 0 0-.319.052.783.783 0 0 0-.245.14.64.64 0 0 0-.157.2.525.525 0 0 0-.056.238c0 .135.044.253.133.353.089.1.224.17.406.207l.693.133c.224.042.422.11.595.203.173.093.317.204.434.332a1.354 1.354 0 0 1 .357.928 1.457 1.457 0 0 1-.465 1.053 1.766 1.766 0 0 1-.56.347 2.053 2.053 0 0 1-.767.133c-.331 0-.616-.048-.854-.143a1.924 1.924 0 0 1-.598-.368 1.567 1.567 0 0 1-.368-.5 1.75 1.75 0 0 1-.154-.543l.896-.238c.01.121.038.238.088.35a.935.935 0 0 0 .535.504c.13.051.285.077.462.077.261 0 .46-.057.598-.171a.544.544 0 0 0 .207-.438.517.517 0 0 0-.154-.375c-.103-.105-.252-.176-.448-.213l-.693-.14c-.397-.08-.713-.241-.949-.486-.235-.246-.353-.557-.353-.935 0-.22.045-.423.136-.612.092-.19.216-.354.375-.494s.343-.25.553-.329c.21-.08.432-.119.665-.119.299 0 .554.04.767.122.212.082.388.186.528.312s.248.265.325.416c.078.152.13.298.158.438l-.868.266Z" />
      </g>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawSpanishIcon);
export default ForwardRef;
